export const SIT_NEXUS_FILTER = {
  NEXUS_ELIGIBLE: "NEXUS_ELIGIBLE",
  NEXUS_INELIGIBLE: "NEXUS_INELIGIBLE",
  NEXUS_REVIEW: "NEXUS_REVIEW",
} as const;

export type SITNexusFilter =
  (typeof SIT_NEXUS_FILTER)[keyof typeof SIT_NEXUS_FILTER];
